module.exports = __webpack_public_path__ + "static/media/banner.b16de497.jpg";